import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetFurtherActionNoticeURLsByWorkerIDsRequest,
  TGetFurtherActionNoticeURLsByWorkerIDsResponse,
} from "./getFurtherActionNoticeURLsByWorkerIDs.schema";

export const getFurtherActionNoticeURLsByWorkerIDs = (
  axios: IAxiosInstance
) => {
  return async (data: TGetFurtherActionNoticeURLsByWorkerIDsRequest) => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TGetFurtherActionNoticeURLsByWorkerIDsResponse>
    >("/api/getFurtherActionNoticeURLsByWorkerIDs", { ...data });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
